import React from "react";

const FullAndFinalSettings = () => {
    return <div>FullAndFinalSettings</div>
}

export default FullAndFinalSettings;